var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvancedChordsMkt = function SvgAdvancedChordsMkt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 2.173C1 1.525 1.525 1 2.173 1h19.654C22.475 1 23 1.525 23 2.173v21.12h-.88V15.96h-3.344v7.333h-.88V15.96h-3.344v7.333h-.88V15.96h-3.344v3.87a1.76 1.76 0 1 1-.88 0v-3.87H6.104v7.333h-.88V15.96H1.88v7.333H1zm.44.587h.44v12.32h3.344v-4.31a1.76 1.76 0 0 1 0-3.407V2.76zm4.664 0v4.602a1.76 1.76 0 0 1 0 3.41v4.308h3.344V2.76zm4.224 0v12.32h3.344V2.76zm4.224 0v12.32h3.344v-4.309a1.76 1.76 0 0 1 0-3.41V2.76zm4.224 0v4.603a1.76 1.76 0 0 1 0 3.407v4.31h3.344V2.76z",
    clipRule: "evenodd"
  })));
};
export default SvgAdvancedChordsMkt;